export const firebaseConfig = {
    apiKey: "AIzaSyC0sYcpZ5AlxNAFks6N6WCmFkK269NFUsc",
    authDomain: "banktopup-39abc.firebaseapp.com",
    projectId: "banktopup-39abc",
    storageBucket: "banktopup-39abc.appspot.com",
    messagingSenderId: "345484183070",
    appId: "1:345484183070:web:741e5370c89c0964a2500f",
    measurementId: "G-2XZD7B2Y2G"
}